module.exports = __webpack_public_path__ + "img/dashbord.e74f8e90.png";